import { ApiGetPharmOrderResponse, ApiPharmOrderRequest, ApiPharmOrderResponse } from 'src/app/core/models';
const pharmOrderOne: ApiPharmOrderResponse = {
  enterpriseOrderId: 'bdfe17a7-d285-482b-823f-2e62e0e8ae82',
  orderNumber: '700057-9319',
  shipBy: '07/19/2023',
  trackingNumber: 'https://www.ups.com/track?loc=en_US&tracknum=1Z2993120395033417',
  pharmacyLocation: 'Roanoke',
  orderStatus: 'Shipped',
  customerAddressId: '',
  customerId: '',
  source: 'Portal',
  items: [{ rxNumber: 7394964, drugDescription: 'VIVAGUARD 30G LANCETS', quantity: 100 }],
};

const pharmOrderTwo: ApiPharmOrderResponse = {
  enterpriseOrderId: '030a2b5c-0b6d-4db4-ba0d-0e50fce2cfd5',
  orderNumber: '700057-9136',
  shipBy: '07/25/2023',
  trackingNumber: '',
  pharmacyLocation: 'Roanoke',
  orderStatus: 'Needs Consent',
  customerAddressId: '',
  customerId: '',
  source: 'Portal',
  items: [
    { rxNumber: 7395130, drugDescription: 'BD 32G X 4 MM NANO PEN NEEDLE  U/F', quantity: 100 },
    { rxNumber: 7395132, drugDescription: 'Omnipods Extra Large', quantity: 10 },
    { rxNumber: 7395133, drugDescription: 'Atorvastatin', quantity: 90 },
  ],
};

const pharmOrderThree: ApiPharmOrderResponse = {
  enterpriseOrderId: '030a2b5c-0b6d-4db4-ba0d-0e50fce2cfd5',
  orderNumber: '700057-9137',
  shipBy: '07/25/2023',
  trackingNumber: '',
  pharmacyLocation: 'Roanoke',
  orderStatus: 'Too Early to Fill',
  customerAddressId: '',
  customerId: '',
  source: 'Portal',
  items: [
    { rxNumber: 7395130, drugDescription: 'BD 32G X 4 MM NANO PEN NEEDLE  U/F', quantity: 100 },
    { rxNumber: 7395132, drugDescription: 'Omnipods Extra Large', quantity: 10 },
    { rxNumber: 7395133, drugDescription: 'Atorvastatin', quantity: 90 },
    { rxNumber: 7395133, drugDescription: 'Flonase', quantity: 70 },
    { rxNumber: 7395133, drugDescription: 'Elderberry', quantity: 60 },
    { rxNumber: 7395133, drugDescription: 'Metformin 40mg', quantity: 90 },
    { rxNumber: 7395133, drugDescription: 'Insulin 100mg', quantity: 80 },
  ],
};

export const getPharmOrders = (): ApiGetPharmOrderResponse => {
  return [pharmOrderOne, pharmOrderTwo, pharmOrderThree];
};

export const getPharmOrder = (): ApiPharmOrderResponse[] => {
  return [pharmOrderOne];
};

export const updatePharmOrder = (_: any, body: ApiPharmOrderRequest): ApiPharmOrderResponse[] => {
  return [pharmOrderOne];
};
